import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Alert, Card } from 'react-bootstrap';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Helmet } from 'react-helmet';
import { useAuth } from '../context/AuthContext';
import Titulo from '../elements/Titulo';
import Pagination from './Pagination';
import IconPlus from '../elements/IconPlus';
import IconDetails from '../elements/IconDetails';
import AlertModal from './AlertModal';
import useAlertModal from '../hooks/useAlertModal';


const PaymentPlan = () => {

    const { user } = useAuth();
    const [payments, setPayments] = useState([]);
    const [installments, setInstallments] = useState([]);
    const [saleDetail, setSaleDetail] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [showDetail, setShowDetail] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dataResponse, setResponseData] = useState([]);
    const { showAlert, showAlertModal, alertMessage, alertType, hideAlert } = useAlertModal();
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 30;
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
    const day = String(now.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const [currentDate, setCurrentDate] = useState(formattedDate);

    // Cargar items desde la API al montar el componente
    useEffect(() => {
        getPaymentPlan();
    }, []);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(payments.length / itemsPerPage);
    const [customerAmount, setCustomerAmount] = useState('');


    const getPaymentPlan = async () => {
        await dotoniwoofApi.get(`/paymentPlan.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setPayments(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };


    const getInstallmentByPP = async (paymentPlan) => {
        await dotoniwoofApi.get(`/installment.php/${paymentPlan.id_payment_plan}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setInstallments(responseApi.message);

                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };


    const totalInstallments = installments.reduce((acc, item) => acc + parseFloat(item.amount), 0);
    const handleEdit = (payment) => {
        getInstallmentByPP(payment)
        setSelectedPayment(payment);
        setShowModal(true);
    };

    const handleShowDetail = (sale) => {
        getSaleDetail(sale);
        setShowDetail(true);
    };


    // Función para cerrar el modal
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedPayment(null);
    };



 const getSaleDetail = async (id_sale) => {
        await dotoniwoofApi.get(`/saleDetail.php/${id_sale}`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setSaleDetail(responseApi.message);
                    console.log(saleDetail);
                }
            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    }

    // Función para filtrar los ítems según el término de búsqueda
    const filteredPaymentByID = payments.filter((payment) => {
        return (
            payment.phone.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    // Función para manejar los cambios en el formulario del modal
    const handleFormChange = (e) => {
        setSelectedPayment({ ...selectedPayment, [e.target.name]: e.target.value });
    };

    const handleCustomerAmountChange = (e) => setCustomerAmount(e.target.value);
    const addPaymentApi = async () => {


        if (!customerAmount.trim()) {
            showAlert("TODOS LOS CAMPOS SON OBLIGATORIOS", 'error');
        } else {
            try {


                const maxInstallment = Math.max(...installments.map(item => parseInt(item.installment_number)));
                const id_sale = installments.map(item => item.id_sale)[0];
                const total_amount = installments.map(item => item.sale_amount)[0];
                const { data } = await dotoniwoofApi.post(`/installment.php`,
                    JSON.stringify({
                        firebase_UID: user.uid,
                        create_date: currentDate,
                        amount: customerAmount,
                        id_sale: id_sale,
                        id_payment_plan: selectedPayment.id_payment_plan,
                        installment_number: (parseInt(maxInstallment) + 1).toString(),
                        total_sale: total_amount
                    }));
                setResponseData(data);
                if (data.code === 201) {
                    showAlert(data.message || 'Abono registrado exitosamente', 'success');
                    setCustomerAmount('');
                    handleCloseModal();
                }
                if (data.code === 200) {
                    showAlert(data.message || 'Error al registrar el abono', 'error');
                    setCustomerAmount('');
                }
            } catch (error) {
                showAlert('Error al procesar el abono. Por favor, intente nuevamente.', 'error');
            }

        }

    }

    const closeModal = () => {
        setShowDetail(false);
        setSaleDetail([]);
    }
    const getColor = (status) => {
        switch (status) {
            case "ABONO SALDADO":
                return "table-success";
            case "INICIO DE ABONO":
                return "table-warning";
            case "EN PROCESO DE ABONO":
                return "table-primary";
            default:
                return "table-danger";
        }
    };


    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Items
            </title></Helmet>


            <div className="container">
                <Titulo>Sistema de abono</Titulo>
                <h3 className="mt-4">Lista de clientes</h3>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginate={paginate}
                />
                <Table striped bordered hover className="mt-3">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Fecha</th>
                            <th>Telefono</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPaymentByID.map((payment) => (
                            <tr key={payment.id_payment_plan}>
                                <td>{payment.name}</td>
                                <td>{payment.created_date}</td>
                                <td>{payment.phone}</td>
                                <td className={getColor(payment.status)}>{payment.status}</td>
                                <td>
                                    <Button variant="success" className="w-100" onClick={() => handleEdit(payment)}>Agregar abono <IconPlus></IconPlus></Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Modal para editar el ítem */}

                {selectedPayment && (
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Agregar Abono</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <strong>Cliente: </strong>{selectedPayment.name}
                            <br></br>
                            <strong>Valor total de venta: </strong>{parseFloat(installments.map(item => item.sale_amount)[0]).toLocaleString("es-CO", { style: "currency", currency: "COP" })}
                            <br></br>
                            <strong>Total Abonado: </strong> {parseFloat(totalInstallments).toLocaleString("es-CO", { style: "currency", currency: "COP" })}
                            <br></br>
                            <Button  variant="success" className="me-2 w-100" onClick={() =>  handleShowDetail(installments.map(item => item.id_sale)[0])}>Detalle de venta <IconDetails>h</IconDetails></Button>
                            <>
                                <br></br>
                                <Table striped bordered hover className="mt-3">
                                    <thead>
                                        <tr>
                                            <th>Valor abono</th>
                                            <th>Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {installments.map((installment) => (
                                            <tr key={installment.id_installment_payment}>
                                                <td> {parseFloat(installment.amount).toLocaleString("es-CO", { style: "currency", currency: "COP" })}</td>
                                                <td>{installment.created_date}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>

                            <>
                                <br></br>
                                <Card body>
                                    <Card.Title><strong>Adicionar Abono</strong></Card.Title>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="formGroupCustomerAmount">
                                            <Form.Label>Valor del abono</Form.Label>
                                            <Form.Control required type="text" value={customerAmount} placeholder="Digite el valor del abono" onChange={handleCustomerAmountChange} />
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Fecha de abono:</Form.Label>
                                            <Form.Control type="date"
                                                value={currentDate}
                                                onChange={(e) => setCurrentDate(e.target.value)} />
                                        </Form.Group>
                                    </Form>
                                </Card>
                            </>


                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                            <Button variant="primary" onClick={addPaymentApi}>Guardar</Button>
                        </Modal.Footer>
                    </Modal>
                )}


                                        {/* Modal para ver el detalle de la venta */}
                                        <Modal show={showDetail} onHide={() => setShowDetail(false)}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Detalle de la Venta</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                
                                                {/* Tabla de Ventas */}
                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th>ID Venta</th>
                                                            <th>Nombre</th>
                                                            <th>Precio</th>
                                                            <th>Peso</th>
                                                            <th>Color</th>
                                                            <th>Talla</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {saleDetail.map((sale) => (
                                                            <tr key={sale.id_sale_detail}>
                                                                <td>{sale.id_sale_detail}</td>
                                                                <td>{sale.description}</td>
                                                                <td>{parseFloat(sale.unit_price).toLocaleString("es-CO", { style: "currency", currency: "COP" })}</td>
                                                                <td>{sale.weight_name}</td>
                                                                <td>{sale.color_name}</td>
                                                                <td>{sale.size_name}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={() => closeModal()}>
                                                    Cerrar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
            </div>


            {/* Modal de Alerta Temporal */}
            <AlertModal
                show={showAlertModal}
                onHide={hideAlert}
                message={alertMessage}
                type={alertType}
            />
        </>

    );
}

export default PaymentPlan;